var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 19.8535,
    width: 10.2353,
    height: 13.5882,
    rx: 1.25,
    transform: "rotate(180 18.75 19.8535)",
    stroke: "#34657F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76448 16.4121L6.24977 16.4121C5.69749 16.4121 5.24977 15.9644 5.24977 15.4121L5.24977 4.00035C5.24977 3.44806 5.69749 3.00035 6.24977 3.00035L14.3086 3.00035C14.8609 3.00035 15.3086 3.44806 15.3086 4.00035L15.3086 5.51505",
    stroke: "#34657F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.1ec415d1b3665b5371f18132ef7154fc.svg";
export { ForwardRef as ReactComponent };